module.exports = __webpack_public_path__ + "static/media/IMG_3995 vanity storage and detail.c2f41eb2.JPG";